import { useContext } from 'react';
import { ConfiguratorContext, ConfiguratorContextType } from './configurator-context';

export function useConfigurator(): ConfiguratorContextType {
	const ctx = useContext(ConfiguratorContext);

	if (!ctx) {
		throw new Error('useConfigurator must be used within a ConfiguratorProvider');
	}

	return ctx;
}

export function useCatalog(): ConfiguratorContextType['catalog'] {
	const ctx = useContext(ConfiguratorContext);

	if (!ctx) {
		throw new Error('useCatalog must be used within a ConfiguratorProvider');
	}

	return ctx.catalog;
}
